const BannerDescription = () => {
  return (
    <div className='flex flex-col justify-between gap-y-[40px] sm:flex-row'>
      <div className='typography-ui-17m md:typography-ui-22m flex flex-col gap-y-[4px] text-gray-500'>
        <span>대한민국 1위 비대면 진료 앱 닥터나우가</span>
        <span>아픈 모든 순간 어디서든 곁에 있어요.</span>
      </div>
    </div>
  );
};

export default BannerDescription;
